<!-- Bannière -->
<section id="banner">
  <div class="banner width-100" style="max-height: 250px; overflow: hidden;"><!-- TODO: #MEDIUM do style without hardcode -->
    <img [src]="banner" alt="Bannière de l'évènement mis en avant" class="width-100">
  </div>
</section>

<!-- A découvrir -->

<!-- Évènements à venir -->
<section id="upcoming-events">
  <div class="container">


    <header class="section-header section-header--column">
      <div class="section-header__first">
        <i class="fa fa-calendar"></i>
        <h1 class="title inline-block coming_event_title">{{ getComingCategory(categorie) }} {{'home.to_come_up'| translate}}</h1>
      </div>
      <div class="section-header__last">
        <ul class="actions align-right flexible compact-children-margin">
          <li [ngClass]="{'active': selected == 'semaine'}"  id="activeWeekEvents"><a (click)="getWeeksevents()"  href="javascript:void(0);" title="Cette semaine" class="text-uppercase">{{'home.this_week'| translate}}</a></li>
          <li [ngClass]="{'active': selected == 'mois'}" id="activeMonthEvents"><a (click)="Monthevents()" href="javascript:void(0);" title="Ce mois" class="text-uppercase">{{'home.this_month'| translate}}</a></li>
        </ul>
      </div>
    </header>





   <!-- <header class="section-header section-header&#45;&#45;column">
      <i class="fa fa-calendar"></i>
      <h1 style="max-width: 148px" class="title inline-block coming_event_title">{{ getComingCategory(categorie) }} {{'home.to_come_up'| translate}}</h1>
      <ul class="actions align-right flexible compact-children-margin">
        <li [ngClass]="{'active': selected == 'semaine'}" ><a (click)="getWeeksevents()" href="javascript:void(0);" title="Cette semaine" class="text-uppercase">{{'home.this_week'| translate}}</a></li>
        <li [ngClass]="{'active': selected == 'mois'}"><a (click)="Monthevents()" href="javascript:void(0);" title="Ce mois" class="text-uppercase">{{'home.this_month'| translate}}</a></li>
      </ul>
    </header>-->

    <div class="section-content">
      <div class="row flexible" >
        <ul class="flexible flex-wrap col-md-6 col-sm-6"  *ngFor="let event of events">
          <li class="event">
            <a [routerLink]="['/event/' ,slugify(event.name), event.id ]" title="" class="inline-block width-100">
              <div class="evt-img-wrapper event-thumbox flexible text-center">
                <div *ngIf="event.thumbnail" class="event-thumbox">
                  <img src="{{ event.thumbnail|assetimage }}" onError="this.src='assets/imgs/banner.png'" alt="Image de l'évènement" class="event-thumb">
                </div>
                <div *ngIf="!event.thumbnail">
                  <img src="{{ event.image|assetimage }}" onError="this.src='assets/imgs/banner.png'"  *ngIf="event.image" alt="Image de l'évènement" class="height-100">
                  <img src="assets/imgs/banner.png" *ngIf="!event.image"  alt="Image de l'évènement" class="height-100">
                </div>
                <!-- <ng-template *ngIf="!event.thumbnail" #banner_content>
                  <img src="{{ event.image|assetimage }}" alt="Image de l'évènement" class="height-100">

                 </ng-template>-->
              </div>

              <div class="evt-details">
                <div class="flexible event-date-wrapper ">
                  <h6 class="inline-block evt-date"> {{event.start_date | datefrench}}</h6>
                  <h6 class="inline-block evt-time">
                    <i class="inline-block fa fa-clock-o"></i>
                    {{ getFormatStartHour(event.start_hour) }}
                  </h6>
                </div>

                <h5 class="block evt-place">{{event.name}}</h5>

                <h6 class="block evt-location">
                  <i class="fa fa-map-marker"></i>
                  {{event.location_name}}
                </h6>
              </div>

              <div class="evt-actionbar flexible">
                <a [routerLink]="['/event/' , slugify(event.name), event.id ]" class="btn btn-style btn-grey" *ngIf="event.has_ticketing==false" >{{'home.see'| translate}}</a>    <!--   [routerLink]="['/event/' , event.id ]"-->
                <a [routerLink]="['/event/' , slugify(event.name), event.id ]" class="btn btn-style" *ngIf="event.has_ticketing==true">{{'home.buy'| translate}}</a>
                <!--  <h6 class="evt-infos text-red" *ngIf="event.has_ticketing==true && event.pricings[0]">
                   <i class="fa fa-ticket"></i>
                   <span>{{event.pricings[0].Totalplace}}</span>
                   Billets disponibles
                 </h6>-->
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
